import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import UITile from 'UIComponents/tile/UITile';
import UITileSection from 'UIComponents/tile/UITileSection';
import Small from 'UIComponents/elements/Small';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HubInfoBox = props => {
  const {
    accountName,
    portalId
  } = props;
  return /*#__PURE__*/_jsx(UITile, {
    compact: true,
    distance: "flush",
    children: /*#__PURE__*/_jsxs(UITileSection, {
      className: "p-all-4",
      children: [/*#__PURE__*/_jsx(TruncateString, {
        "data-test-id": "hub-info-box-account-name",
        children: accountName
      }), /*#__PURE__*/_jsx(Small, {
        use: "help",
        "data-test-id": "hub-info-box-portal-id",
        children: portalId
      })]
    })
  });
};
export default HubInfoBox;